import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import { post } from "../../../helpers/api_helper";
import {
  POST_VoucherSeriesTransactionTypeList,
  POST_GetVoucherSeriesDetailByID,
  POST_VoucherSeriesInsert,
  POST_VoucherSeriesUpdate,
  POST_GetRequestTypeDDLList,
} from "../../../helpers/url_helper";
import moment from "moment";

import { Spin } from "antd";
import { errorMessage, successMessage } from "../CommonFunctions";

const AddVoucherSeries = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();
  const [transTypeOptions, setTransTypeOptions] = useState([]);
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const loadTransTypeDDL = async () => {
    setIsLoading(true);
    await post(POST_VoucherSeriesTransactionTypeList, {
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      LoginIDEncrypted: AuthUser?.LoginIDEncrypt,
    })
      .then((res) => {
        if (res.IsSuccess) {
          // let mainList = res?.List?.filter((x) => x.TranTypeID <= 8);
          setTransTypeOptions(
            res.List.map((item) => ({
              label: item.TranTypeName,
              value: item.TranTypeID,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const resetOnOptions = [
    { label: "By Effective Date", value: 1 },
    { label: "Daily", value: 2 },
    { label: "Monthly", value: 3 },
    { label: "Yearly", value: 4 },
    // { label: "NABL", value: 5 },
  ];

  const resetOnDailyOptions = [
    { label: moment().format("D") + " (D)", value: "D" },
    { label: moment().format("DD") + " (DD)", value: "DD" },
    // { label: moment().format("DM") + " (DM)", value: "DM" },
    { label: moment().format("DDMM") + " (DDMM)", value: "DDMM" },
    // { label: moment().format("DMYY") + " (DMYY)", value: "DMYY" },
    // { label: moment().format("DMYYYY") + " (DMYYYY)", value: "DMYYYY" },
    { label: moment().format("DDMMYY") + " (DDMMYY)", value: "DDMMYY" },
    { label: moment().format("DDMMYYYY") + " (DDMMYYYY)", value: "DDMMYYYY" },
    // { label: moment().format("MD") + " (MD)", value: "MD" },
    { label: moment().format("MMDD") + " (MMDD)", value: "MMDD" },
    // { label: moment().format("MDYY") + " (MDYY)", value: "MDYY" },
    // { label: moment().format("MDYYYY") + " (MDYYYY)", value: "MDYYYY" },
    { label: moment().format("MMDDYY") + " (MMDDYY)", value: "MMDDYY" },
    { label: moment().format("MMDDYYYY") + " (MMDDYYYY)", value: "MMDDYYYY" },
    { label: moment().format("YYMMDD") + " (YYMMDD)", value: "YYMMDD" },
    { label: moment().format("YYYYMMDD") + " (YYYYMMDD)", value: "YYYYMMDD" },
  ];

  const resetOnMonthlyOptions = [
    { label: moment().format("M") + " (M)", value: "M" },
    { label: moment().format("MM") + " (MM)", value: "MM" },
    // { label: moment().format("MYY") + " (MYY)", value: "MYY" },
    // { label: moment().format("MYYYY") + " (MYYYY)", value: "MYYYY" },
    { label: moment().format("MMYY") + " (MMYY)", value: "MMYY" },
    { label: moment().format("MMYYYY") + " (MMYYYY)", value: "MMYYYY" },
    { label: moment().format("YYMM") + " (YYMM)", value: "YYMM" },
    { label: moment().format("YYYYMM") + " (YYYYMM)", value: "YYYYMM" },
  ];

  const resetOnYearlyOptions = [
    { label: moment().format("YY") + " (YY)", value: "YY" },
    { label: moment().format("YYYY") + " (YYYY)", value: "YYYY" },
  ];

  // const resetOnFormatOptions = [
  //   { label: moment().format("D") + " (D)", value: "D" },
  //   { label: moment().format("DD") + " (DD)", value: "DD" },
  //   { label: moment().format("M") + " (M)", value: "M" },
  //   { label: moment().format("MM") + " (MM)", value: "MM" },
  //   { label: moment().format("YY") + " (YY)", value: "YY" },
  //   { label: moment().format("YYYY") + " (YYYY)", value: "YYYY" },
  // ];

  const zeroPaddingOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];

  const validationSchema = Yup.object().shape({
    TranType: Yup.string().required("Transaction Type is required field"),
    Prefix: Yup.string().trim().required("Prefix is required field"),
    StartFrom: Yup.string().required("Start From is required field"),
    //  NosLength: Yup.string().required("Nos Length is required field"),
    //EffectiveDate: Yup.string().required("Effective Date is required field"),
    ResetOn: Yup.string().required("Reset On is required field"),
    StartDate: Yup.string().required("Start Date is required field"),
    EndDate: Yup.string().required("End Date is required field"),

    NosLength: Yup.string().when("ZeroPadding", ([ZeroPadding], schema) => {
      if (ZeroPadding == true)
        return Yup.string().required("Nos Length is required field");
      return schema;
    }),

    ResetOnDateFormat: Yup.string().when("ResetOn", ([ResetOn], schema) => {
      if (ResetOn != 1)
        return Yup.string().required("Reset On Date Format is required field");
      return schema;
    }),

    RequestType: Yup.string().when("TranType", ([TranType], schema) => {
      if (TranType == 5)
        return Yup.string().required("Request Type is required field");
      return schema;
    }),

    // EndDate: Yup.string().when("TranType", ([TranType], schema) => {
    //   /* TranType: 5 = "TC No", 15 = "Proforma Invoice" */
    //   if (TranType == 5 || TranType == 15)
    //     return Yup.string().required("End Date is required field");
    //   return schema;
    // }),
    // StartPeriod: Yup.string().when("ResetOn", ([ResetOn], schema) => {
    //   if (ResetOn != 1)
    //     return Yup.string().required("Start Period is required field");
    //   return schema;
    // }),
    // ToDate: Yup.string().when("TranType", ([TranType], schema) => {
    //   /* TranType: 5 = "TC No", 15 = "Proforma Invoice" */
    //   if (TranType == 5 || TranType == 15)
    //     return Yup.string().required("To Date is required field");
    //   return schema;
    // }),
    // Location: Yup.string().when(
    //   ["TranType", "ResetOn"],
    //   ([TranType, ResetOn], schema) => {
    //     /* TranType: 5 = "TC No", ResetOn: 5 = "NABL" */
    //     if (TranType == 5 && ResetOn == 5)
    //       return Yup.string().required("Location is required field");
    //     return schema;
    //   }
    // ),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      VoucherSeriesIDEncrypt: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      TranType: "",
      Prefix: "",
      StartFrom: "",
      Suffix: "",
      NosLength: "",
      ZeroPadding: false,
      //EffectiveDate: new Date(),
      ResetOn: "",
      StartPeriod: "",
      BranchID: "",
      CompanyID: "",
      StartDate: "",
      EndDate: "",
      //ToDate: new Date(),
      Accredited: false,
      OnSiteTesting: false,
      TallySync: false,
      SendEmail: false,
      NoBill: false,
      NABLSeries: false,
      VoucherSeriesNo: "",
      IsTCNoBasedOnInwardNo: false,
      ResetOnDateFormat: "",
      ResetOnSeparator: "",
      RequestType: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      Prefix,
      StartFrom,
      Suffix,
      NosLength,
      ZeroPadding,
      VoucherSeriesNo,
      ResetOn,
      TranType,
      // EffectiveDate,
      StartDate,
      EndDate,
      // ToDate,
      Accredited,
      OnSiteTesting,
      TallySync,
      SendEmail,
      NoBill,
      IsTCNoBasedOnInwardNo,
      ResetOnDateFormat,
      ResetOnSeparator,
    },
  } = formik;

  useEffect(() => {
    if (!StartDate) {
      formik.setFieldValue("StartDate", "");
    }
    if (!EndDate) {
      formik.setFieldValue("EndDate", "");
    } else {
      if (StartDate && EndDate < StartDate) {
        formik.setFieldValue("EndDate", StartDate);
      }
    }
  }, [StartDate, EndDate]);

  const getVoucherDetailsByID = () => {
    setIsLoading(true);
    post(POST_GetVoucherSeriesDetailByID, {
      VoucherSeriesIDEncrypt: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
            StartDate: new Date(response?.EffectiveDate),
            EndDate: response?.ToDate ? new Date(response?.ToDate) : "",
            NosLength: response?.NosLength == 0 ? "" : response?.NosLength,
            RequestType:
              response?.RequestType == 0 ? "" : response?.RequestType,
          });
          createSampleVoucherNo(
            response?.Prefix,
            response?.StartFrom,
            response?.Suffix,
            response?.NosLength,
            response?.ZeroPadding,
            response?.ResetOn,
            response?.ResetOnDateFormat,
            response?.ResetOnSeparator,
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    loadTransTypeDDL();
    getRequestTypeDDL();
    if (PrimaryIdParam) {
      getVoucherDetailsByID();
    }
  }, []);

  function createSampleVoucherNo(
    Prefix,
    StartFrom,
    Suffix,
    NosLength,
    ZeroPadding,
    resetOn,
    resetOnDateFormat,
    resetOnSeparator,
  ) {
    /*Reset On: 1 = "Effective Date", 2 = "Daily", 3 = "Monthly", 4 = "Yearly" */
    if (Prefix) {
      let voucherNo = Prefix;
      if (resetOn == 2 || resetOn == 3 || resetOn == 4) {
        if (resetOnDateFormat) {
          voucherNo += moment().format(resetOnDateFormat);
        } else {
          if (ResetOn == 2) {
            voucherNo += moment().format("D");
          } else if (ResetOn == 3) {
            voucherNo += moment().format("M");
          } else if (ResetOn == 4) {
            voucherNo += moment().format("YYYY");
          }
        }
        if (resetOnSeparator) {
          voucherNo += resetOnSeparator;
        }
      }
      if (ZeroPadding) {
        voucherNo += StartFrom.toString().padStart(NosLength, "0");
      } else {
        voucherNo += StartFrom.toString();
      }
      voucherNo += Suffix;
      formik.setFieldValue("VoucherSeriesNo", voucherNo);
    } else {
      formik.setFieldValue("VoucherSeriesNo", "");
    }
  }

  useEffect(() => {
    createSampleVoucherNo(
      Prefix,
      StartFrom,
      Suffix,
      NosLength,
      ZeroPadding,
      ResetOn,
      ResetOnDateFormat,
      ResetOnSeparator,
    );
  }, [
    Prefix,
    StartFrom,
    Suffix,
    NosLength,
    ZeroPadding,
    ResetOn,
    ResetOnDateFormat,
    ResetOnSeparator,
  ]);

  const handleValidSubmit = (values) => {
    setIsLoading(true);

    let payload = {
      ...values,
      EffectiveDate: moment(values?.StartDate)
        .format("YYYY-MM-DD")
        .replace(/^\-/, ""),
      ToDate: values?.EndDate
        ? moment(values?.EndDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      // ToDate:
      //   TranType == 5 || TranType == 15
      //     ? moment(values?.EndDate).format("YYYY-MM-DD").replace(/^\-/, "")
      //     : "",
      NosLength: values?.NosLength ? values?.NosLength : 0,
      StartPeriod: values.StartPeriod ? values.StartPeriod : 0,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      RequestType: values?.RequestType ? values?.RequestType : 0,
    };
    //console.log("payload: ", payload);

    post(
      PrimaryIdParam ? POST_VoucherSeriesUpdate : POST_VoucherSeriesInsert,
      payload,
    )
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          // swal("Success!", response?.Message, "success");
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/voucher-series");
          }, 1000);
        } else {
          //  swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [requestTypeOptions, setRequestTypeOptions] = useState([]);

  const getRequestTypeDDL = async () => {
    //setIsLoading(true);
    await post(POST_GetRequestTypeDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setRequestTypeOptions(
            response?.List?.map((item) => ({
              label: item?.RequestTypeName,
              value: item?.RequestType,
            })),
          );
        }
        //setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">
                {PrimaryIdParam ? "Edit" : "Add"} Voucher Series
              </h4>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Row>
                    <Col lg={3}>
                      <Field
                        label="Transaction Type"
                        name="TranType"
                        placeholder={"Select Transaction Type"}
                        options={transTypeOptions}
                        component={CustomSelect}
                        required
                        autoFocus
                        isDisabled={PrimaryIdParam ? true : false}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        label="Reset On"
                        name="ResetOn"
                        placeholder={"Select Reset On"}
                        options={resetOnOptions}
                        component={CustomSelect}
                        onChange={(e) => {
                          formik.setFieldValue("ResetOn", e?.value);
                          formik.setFieldValue("ResetOnDateFormat", "");
                        }}
                        isClearable={false}
                        required
                      />
                    </Col>

                    <Col lg={3}>
                      <Field
                        label="Prefix"
                        name="Prefix"
                        placeholder={"Enter Prefix"}
                        component={CustomInput}
                        required
                        maxLength={20}
                      />
                    </Col>

                    {ResetOn && ResetOn != 1 && (
                      <>
                        <Col lg={3}>
                          <Field
                            label="Reset On Date Format"
                            name="ResetOnDateFormat"
                            placeholder={"Select Reset On Date Format"}
                            component={CustomSelect}
                            options={
                              ResetOn == 2
                                ? resetOnDailyOptions
                                : ResetOn == 3
                                  ? resetOnMonthlyOptions
                                  : ResetOn == 4
                                    ? resetOnYearlyOptions
                                    : []
                            }
                            required
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label="Reset On Separator"
                            name="ResetOnSeparator"
                            placeholder={"Enter Reset On Separator"}
                            component={CustomInput}
                            maxLength={20}
                          />
                        </Col>
                      </>
                    )}

                    <Col lg={3}>
                      <Field
                        type="number"
                        label="Start Series From"
                        name="StartFrom"
                        placeholder={"Enter Start Series From"}
                        component={CustomInput}
                        required
                        onChange={(e) => {
                          formik.setFieldValue(
                            "StartFrom",
                            e?.target?.value?.slice(0, 4), //to set maxLength 4
                          );
                        }}
                        numberTypeWithoutDot={true}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        label="Suffix"
                        name="Suffix"
                        placeholder={"Enter Suffix"}
                        component={CustomInput}
                        maxLength={20}
                      />
                    </Col>

                    <Col lg={3}>
                      <Field
                        label="Zero Padding"
                        name="ZeroPadding"
                        placeholder={"Select Zero Padding"}
                        options={zeroPaddingOptions}
                        component={CustomSelect}
                        isClearable={false}
                        onChange={(e) => {
                          formik.setFieldValue("ZeroPadding", e?.value);
                          if (e?.value == false) {
                            formik.setFieldValue("NosLength", "");
                          }
                        }}
                        // required
                      />
                    </Col>
                    {ZeroPadding ? (
                      <Col lg={3}>
                        <Field
                          type="number"
                          label="Series No Length"
                          name="NosLength"
                          placeholder={"Enter Series No Length"}
                          component={CustomInput}
                          required
                          onChange={(e) => {
                            formik.setFieldValue(
                              "NosLength",
                              e?.target?.value?.slice(0, 2), //to set maxLength 2
                            );
                          }}
                          numberTypeWithoutDot={true}
                        />
                      </Col>
                    ) : (
                      ""
                    )}

                    <Col lg={3}>
                      <Field
                        label="Start Date"
                        name="StartDate"
                        placeholder={"Select Start Date"}
                        component={CustomFlatpickr}
                        options={{
                          altInput: true,
                          altFormat: "j-M-Y",
                          dateFormat: "d-m-Y",
                        }}
                        required
                      />
                    </Col>

                    <Col lg={3}>
                      <Field
                        label="End Date"
                        name="EndDate"
                        placeholder={"Select End Date"}
                        component={CustomFlatpickr}
                        options={{
                          altInput: true,
                          altFormat: "j-M-Y",
                          dateFormat: "d-m-Y",
                          minDate: StartDate ? new Date(StartDate) : new Date(),
                        }}
                        required
                      />
                    </Col>
                    {TranType == 1 ? (
                      <Col lg={3}>
                        <label className="mb-1">
                          TC No based on Inward No{" "}
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            responsive={true}
                            overlay={
                              <Tooltip className="toltip-popover">
                                <strong className="p-1">
                                  TC No will be auto genrated while Material
                                  Inward
                                </strong>
                              </Tooltip>
                            }
                          >
                            <span>
                              <i
                                className="fa fa-info-circle"
                                style={{ cursor: "pointer", color: "#9698ab" }}
                              ></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <div className="mb-2 form-control form-control-sm">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="IsTCNoBasedOnInwardNo"
                            checked={IsTCNoBasedOnInwardNo}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "IsTCNoBasedOnInwardNo",
                                e?.target?.checked,
                              );
                              if (e?.target?.checked === false) {
                                formik.setFieldValue("NABLSeries", false);
                              }
                            }}
                          />
                          <label
                            className="form-check-label ms-2"
                            htmlFor="IsTCNoBasedOnInwardNo"
                          >
                            TC No based on Inward No
                          </label>
                        </div>
                      </Col>
                    ) : (
                      ""
                    )}
                    {TranType == 5 || IsTCNoBasedOnInwardNo == true ? (
                      <Col lg={3}>
                        <Field
                          label="NABL Series"
                          name="NABLSeries"
                          placeholder={"Select NABL Series"}
                          options={zeroPaddingOptions}
                          component={CustomSelect}
                          isClearable={false}
                        />
                      </Col>
                    ) : (
                      ""
                    )}
                    {TranType == 6 || TranType == 15 ? (
                      <Col lg={3}>
                        <Field
                          label="Send Email"
                          name="SendEmail"
                          placeholder={"Select Send Email"}
                          options={zeroPaddingOptions}
                          component={CustomSelect}
                          isClearable={false}
                        />
                      </Col>
                    ) : (
                      ""
                    )}
                    {TranType == 6 ? (
                      <>
                        <Col lg={3}>
                          <Field
                            label="Tally Sync"
                            name="TallySync"
                            placeholder={"Select Tally Sync"}
                            options={zeroPaddingOptions}
                            component={CustomSelect}
                            isClearable={false}
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label="No Bill"
                            name="NoBill"
                            placeholder={"Select No Bill"}
                            options={zeroPaddingOptions}
                            component={CustomSelect}
                            isClearable={false}
                          />
                        </Col>{" "}
                      </>
                    ) : (
                      ""
                    )}

                    {/* <Col lg={3}>
                      <Field
                        type="number"
                        label="Start Period"
                        name="StartPeriod"
                        placeholder={"Enter Start Period"}
                        component={CustomInput}
                        required
                      />
                    </Col> */}

                    {/* {TranType == 5 || TranType == 15 ? (
                      /* TranType: 5 = "TC No", 15 = "Proforma Invoice" */}

                    {/* ) : (
                      ""
                    )} */}

                    {/* {TranType == 5 && ResetOn == 5 ? ( */}
                    {/* /* TranType: 5 = "TC No", ResetOn: 5 = "NABL" */}
                    {/* <Col lg={3}>
                      <Field
                        type="number"
                        label="Location"
                        name="Location"
                        placeholder={"Enter Location"}
                        component={CustomInput}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "Location",
                            e?.target?.value?.slice(0, 1) //to set maxLength 1
                          );
                        }}
                        required
                      />
                    </Col> */}
                    {/* // ) : (
                    //   ""
                    // )} */}
                    {/* </Row>
                  <Row> */}
                    {/* {TranType == 1 || TranType == 5 || TranType == 15 ? (
                    // <Col lg={2}>
                      //   <span className="form-check d-inline-block">
                      //     <input
                      //       type="checkbox"
                      //       className="form-check-input"
                      //       id="Accredited"
                      //       name="Accredited"
                      //       checked={Accredited}
                      //       onChange={(e) => {
                      //         formik.setFieldValue(
                      //           "Accredited",
                      //           e.target.checked
                      //         );
                      //       }}
                      //     />
                      //     <label
                      //       className="form-check-label"
                      //       htmlFor="Accredited"
                      //     >
                      //       Accredited
                      //     </label>
                      //   </span>
                      // </Col>
                    ) : (
                      ""
                    )} */}

                    {/* {TranType == 5 ? (
                    
                     <Col lg={2}>
                        <span className="form-check d-inline-block">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="OnSiteTesting"
                            name="OnSiteTesting"
                            checked={OnSiteTesting}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "OnSiteTesting",
                                e.target.checked
                              );
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="OnSiteTesting"
                          >
                            On Site Testing
                          </label>
                        </span>
                      </Col>
                    ) : (
                      ""
                    )} */}

                    {/* {TranType == 6 ? (
                     
                       <Col lg={2}>
                        <span className="form-check d-inline-block">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="TallySync"
                            name="TallySync"
                            checked={TallySync}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "TallySync",
                                e.target.checked
                              );
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="TallySync"
                          >
                            Tally Sync
                          </label>
                        </span>
                      </Col>
                    ) : (
                      ""
                    )} */}

                    {/* {TranType == 6 || TranType == 15 ? (
                      /* TranType: 6 = "Invoice", 15 = "Proforma Invoice"*/}
                    {/* <Col lg={2}>
                        <span className="form-check d-inline-block">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="SendEmail"
                            name="SendEmail"
                            checked={SendEmail}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "SendEmail",
                                e.target.checked
                              );
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="SendEmail"
                          >
                            Send Email
                          </label>
                        </span>
                      </Col>
                    ) : (
                      ""
                    )} */}

                    {/* {TranType == 6 ? (
                   
                      <Col lg={2}>
                        <span className="form-check d-inline-block">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="NoBill"
                            name="NoBill"
                            checked={NoBill}
                            onChange={(e) => {
                              formik.setFieldValue("NoBill", e.target.checked);
                            }}
                          />
                          <label className="form-check-label" htmlFor="NoBill">
                            No Bill
                          </label>
                        </span>
                      </Col>
                    ) : (
                      ""
                    )} */}
                    {TranType == 5 && (
                      <Col lg={3}>
                        <Field
                          label="Request Type"
                          name="RequestType"
                          placeholder={"Select Request Type"}
                          options={requestTypeOptions}
                          component={CustomSelect}
                          required
                        />
                      </Col>
                    )}

                    <Col lg={12}>
                      <span className="text-primary">{VoucherSeriesNo}</span>
                    </Col>
                  </Row>
                  <hr className="mt-1 mb-2"></hr>
                  <button type="submit" className="btn btn-primary btn-sm me-2">
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </Form>
              </FormikProvider>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};
export default AddVoucherSeries;
